export default __webpack_public_path__ + "static/media/calm1.8e3e546e.png";